import { Component } from '@angular/core';
import { SkeletonComponent } from '@/components/skeleton/skeleton.component';

@Component({
  selector: 'documents-form-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './documents-form-skeleton.component.html'
})
export class DocumentsFormSkeletonComponent {
  rows = [1, 2, 3, 4];
}
